import axios, { type AxiosInstance, type AxiosResponse } from 'axios';
import MainURL from './MainURL';

// 이 서버로 가는 모든 요청에 로그인 토큰을 붙인다 — 서버가 요청의 userAccount 와 토큰 계정을 대조한다
// (server/routers/common/accountBinding.js). 이미 Authorization 이 있는 요청은 건드리지 않는다.
const MAIN_HOSTS = [MainURL, MainURL.replace('://', '://www.')];

axios.interceptors.request.use((config) => {
  const url = `${config.baseURL || ''}${config.url || ''}`;
  if (!MAIN_HOSTS.some((h) => url.startsWith(h))) return config;
  if (config.headers.has('Authorization')) return config;
  try {
    const token = localStorage.getItem('refreshToken');
    if (token) config.headers.set('Authorization', `Bearer ${token}`);
  } catch {
    // 저장소 접근 불가(사생활 보호 모드 등) — 토큰 없이 진행
  }
  return config;
});

// 서버가 만료된 토큰 대신 새 토큰을 내려주면 저장 (X-Refreshed-Token)
export function saveRefreshedToken(response: AxiosResponse) {
  const next = response?.headers?.['x-refreshed-token'];
  if (typeof next === 'string' && next) {
    try {
      localStorage.setItem('refreshToken', next);
    } catch {
      // 저장 실패는 무시 — 다음 요청에서 다시 갱신된다
    }
  }
  return response;
}

export function attachTokenRefresh(instance: AxiosInstance) {
  instance.interceptors.response.use(saveRefreshedToken, (error) => {
    if (error?.response) saveRefreshedToken(error.response);
    return Promise.reject(error);
  });
}

attachTokenRefresh(axios);
